import type { IncidentReportContext } from './incident-context';
import { create } from 'zustand';

export type IncidentDrawerScope = {
  /** Pre-selected itinerary (from an itinerary page) — locks the picker. */
  itineraryId?: string;
  /** Human ref shown while locked. */
  itineraryRef?: string;
  /**
   * Optional "where did this happen" context. Any entry point may pass what
   * it knows (source module, entity, tab, planner day, …); the modal falls
   * back to auto-deriving from the current route. Display + future-ready —
   * does not change today's persisted behaviour. See incident-context.ts.
   */
  context?: IncidentReportContext;
};

type IncidentDrawerState = {
  /** "My incidents" slide-over. */
  open: boolean;
  /** Report-incident modal. */
  reportOpen: boolean;
  scope: IncidentDrawerScope;
  openDrawer: () => void;
  closeDrawer: () => void;
  /** Open the report modal directly (e.g. from an itinerary page). */
  openReport: (scope?: IncidentDrawerScope) => void;
  closeReport: () => void;
};

// Cross-page overlay state for the incidents drawer + report modal. Lives in
// the entities layer so both the widget (trigger/drawer) and the feature
// (report modal) can read it without a widget↔feature import cycle. Mirrors
// the task-drawer store pattern.
export const useIncidentDrawerStore = create<IncidentDrawerState>()((set) => ({
  open: false,
  reportOpen: false,
  scope: {},
  openDrawer: () => set({ open: true, scope: {} }),
  closeDrawer: () => set({ open: false }),
  openReport: (scope = {}) => set({ reportOpen: true, scope }),
  closeReport: () => set({ reportOpen: false }),
}));
